import Image from 'next/image';
import Link from 'next/link';
import cn from 'classnames';
import styles from './index.module.scss';

const Rrss = ({ route, icon, ariaLabel }) => {
  return (
    <Link href={route} target="_blank" aria-label={ariaLabel}>
      <div
        className={cn(
          'relative w-62 h-62 rounded-full bg-red border border-solid border-white flex items-center justify-center',
          styles.socialBtn
        )}
      >
        <div className="relative z-1 w-[14px] h-[14px]">
          <Image
            src={icon}
            fill
            sizes="14px"
            alt=""
            className={cn(styles.socialImg)}
          />
        </div>
      </div>
    </Link>
  );
};
export default Rrss;
